import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LogFeedService } from 'src/app/services/log-activity/logs-feeds.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';
import { AppState } from 'src/app/store/app.state';
import DateUtils from 'src/app/utils/date';
import { map } from 'src/assets/calendar-assets/core/locales-all';

@Component({
  selector: 'app-client-engagement',
  templateUrl: './client-engagement.component.html',
  styleUrls: ['./client-engagement.component.css']
})

export class ClientEngagementComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject();
  id;
  user;
  teamId;
  type;
  arr = [];
  yearValue;
  payload;
  activityLogs;
  showGraph = false;
  activityTypes = {};
  dateUtil = new DateUtils;
  clientFilt = { year: new Date().getFullYear() };
  selectedIds = null;
  selectedType = null;

  constructor(
    private logActSrv: LogActivityService,
    private performRepSrv: PerformanceReportService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.user = info.user.id;
      this.teamId = info.user.teamID;
    });
    this.yearValue = this.dateUtil.getYears();
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.handleDateFilter()
      }
    })
  }

  ngOnInit() {
    this.handleDateFilter()
  }

  handleDateFilter() {
    this.showGraph = false;
    this.getPayload();
    this.fetchLogActivityTypes();
  }

  fetchLogActivityTypes() {
    this.logActSrv.getActivityTypes().pipe(takeUntil(this.unsubscribe)).subscribe(activityLogs => {
      if (activityLogs) {
        this.getActivityLogs(activityLogs)
      }
    })
  }

  resetActivityTypes() {
    this.showGraph = false;
    // Object.keys(this.activityTypes).forEach(key => this.activityTypes[key] = 0);
  }

  getPayload() {
    const { year } = this.clientFilt;
    let type = this.selectedType === "salesperson" ? 2 : this.selectedType === "team" ? 4 : null;
    this.payload = {
      from: Date.parse(new Date(`01/01/${year}`).toISOString()),
      to: Date.parse(new Date(`12/31/${year}`).toISOString()),
      type: type || 2,
      userID: this.selectedIds && type == 2 ? this.selectedIds.map(i => i.toString()) : null,
      teamID: this.selectedIds && type == 4 ? this.selectedIds.map(i => i.toString()) : null,
    }
  }

  getActivityLogs(activityLogsTypes) {
    this.logActSrv.fetchByDate(this.payload).pipe(takeUntil(this.unsubscribe)).subscribe((activityLogs: any) => {
      let activityList = {};
      activityLogsTypes.forEach((res: any) => {
        activityList[res.name] = 0;
      });
      activityLogs.forEach(activity => {
        const actType = activity.type;
        const actCount = activityList[actType];
        if (actCount || actCount === 0) {
          activityList[actType] = actCount + 1;
        }
      });
      this.arr = Object.keys(activityList).map(type => ({ type, value: activityList[type] }));
      this.showGraph = true;
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
